module.exports = __webpack_public_path__ + "img/benefits.b6d8aa47.jpg";